"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSSN = exports.isValidSSN = exports.formatFederalEIN = exports.isValidFederalEIN = exports.formatPhoneNumber = exports.isValidPhone = exports.formatPostalCode = exports.isValidPostalCode = exports.isValidURL = exports.isValidEmail = exports.showdownConverter = void 0;
const showdown_1 = __importDefault(require("showdown"));
exports.showdownConverter = new showdown_1.default.Converter({
    tables: true,
    simpleLineBreaks: true,
    smoothLivePreview: true,
    openLinksInNewWindow: true,
    disableForced4SpacesIndentedSublists: true,
    ghCompatibleHeaderId: true,
    splitAdjacentBlockquotes: true,
    tasklists: true,
});
const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return false;
    }
    // Extract domain part
    const parts = email.split("@");
    if (parts.length !== 2) {
        return false;
    }
    const domain = parts[1];
    const domainParts = domain.split(".");
    // Domain must have at least 2 parts (e.g., example.com)
    if (domainParts.length < 2) {
        return false;
    }
    // Only require the TLD (last part) to be at least 2 characters
    // Domain names (like "b" in "b.com") can be single character
    // But TLDs (like "com") must be at least 2 characters to prevent "d@s.a"
    const tld = domainParts[domainParts.length - 1];
    return tld.length >= 2;
};
exports.isValidEmail = isValidEmail;
const isValidURL = (url) => {
    if (!url || url.trim().length === 0) {
        return false;
    }
    const trimmedUrl = url.trim();
    // Check if it's a valid URL format
    let urlObj;
    try {
        urlObj = new URL(trimmedUrl);
    }
    catch (_a) {
        try {
            urlObj = new URL(`https://${trimmedUrl}`);
        }
        catch (_b) {
            return false;
        }
    }
    // Validate that the hostname is a proper domain
    // Must have at least one dot (like example.com) or be localhost
    const hostname = urlObj.hostname;
    if (!hostname || hostname.length === 0) {
        return false;
    }
    // Allow localhost
    if (hostname === "localhost" || hostname.startsWith("localhost:")) {
        return true;
    }
    // Must contain at least one dot and have valid domain structure
    // Domain should have at least: one character, dot, and TLD (at least 2 chars)
    const domainPattern = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    return domainPattern.test(hostname);
};
exports.isValidURL = isValidURL;
const isValidPostalCode = (postalCode) => {
    if (!postalCode || postalCode.trim().length === 0) {
        return false;
    }
    const trimmed = postalCode.trim();
    // Match exact formats: ##### (5 digits) or #####-#### (5 digits, dash, 4 digits)
    const postalCodeRegex = /^(\d{5}|\d{5}-\d{4})$/;
    return postalCodeRegex.test(trimmed);
};
exports.isValidPostalCode = isValidPostalCode;
const formatPostalCode = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "");
    // Format as #####-####
    if (digits.length <= 5) {
        return digits;
    }
    else {
        return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
    }
};
exports.formatPostalCode = formatPostalCode;
const isValidPhone = (phone) => {
    if (!phone || phone.trim().length === 0) {
        return false;
    }
    const trimmed = phone.trim();
    // Match exact format: ###-###-#### (3 digits, dash, 3 digits, dash, 4 digits)
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    return phoneRegex.test(trimmed);
};
exports.isValidPhone = isValidPhone;
const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "");
    // Format as ###-###-####
    if (digits.length <= 3) {
        return digits;
    }
    else if (digits.length <= 6) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    else {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }
};
exports.formatPhoneNumber = formatPhoneNumber;
const isValidFederalEIN = (ein) => {
    if (!ein || ein.trim().length === 0) {
        return false;
    }
    const trimmed = ein.trim();
    // Match exact format: ##-####### (2 digits, dash, 7 digits)
    const einRegex = /^\d{2}-\d{7}$/;
    return einRegex.test(trimmed);
};
exports.isValidFederalEIN = isValidFederalEIN;
const formatFederalEIN = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "");
    // Format as ##-#######
    if (digits.length <= 2) {
        return digits;
    }
    else {
        return `${digits.slice(0, 2)}-${digits.slice(2, 9)}`;
    }
};
exports.formatFederalEIN = formatFederalEIN;
const isValidSSN = (ssn) => {
    if (!ssn || ssn.trim().length === 0) {
        return false;
    }
    const trimmed = ssn.trim();
    // Match exact format: XXX-XX-XXXX (3 digits, dash, 2 digits, dash, 4 digits)
    const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
    return ssnRegex.test(trimmed);
};
exports.isValidSSN = isValidSSN;
const formatSSN = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "");
    // Format as XXX-XX-XXXX
    if (digits.length <= 3) {
        return digits;
    }
    else if (digits.length <= 5) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    else {
        return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 9)}`;
    }
};
exports.formatSSN = formatSSN;
